<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits } from 'vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    value: {
        type: [String, Number],
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
        default: ''
    }
});

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emits = defineEmits([
    'input',
]);

/*==================================================================*/
/*================== MÉTODOS =======================================*/
/*==================================================================*/

const onInput = (event) => {

    emits('input', event);

}

</script>

<template>

    <v-text-field
        class="c-text-field"
        :label="props.label"
        :value="props.value"
        :disabled="props.disabled"
        :placeholder="props.placeholder"
        outlined
        hide-details
        @input="onInput($event)"
    ></v-text-field>

</template>

<style scoped>

.c-text-field{
    padding: 2px;
}

.c-text-field >>> .v-input__slot{
    min-height: 48px;
}

</style>
